import {useEffect,useState} from 'react'
import {useDispatch,useSelector} from 'react-redux'
import {envAwarePost} from '../../util/util'
import useStripePromise from '../../hooks/useStripeAccount'
import { Elements, ElementsConsumer } from '@stripe/react-stripe-js'
import {useStripe, useElements, PaymentElement} from '@stripe/react-stripe-js'
import { CardElement } from '@stripe/react-stripe-js'
import CenteredLoader from '../CenteredLoader/CenteredLoader'
import LocaleCurrency from '../LocaleCurrency/LocaleCurrency'
import LocaleDate from '../LocaleDate/LocaleDate'
import Spinner from 'react-bootstrap/Spinner'
import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'
import {getInvoice,markInvoicePaid,updateName} from './slice'
import {editInvoice} from '../FinancialsDashboard/Invoices/slice'

import {usePurchaseItemForms} from '../FinancialsDashboard/hooks'
import {updateProgramAssign} from '../FinancialsDashboard/Packages/packagesSlice'
import {setMultiFormsModal} from '../../state/customFormsSlice'

const Invoice = ({invoice})=>{
	
	const stripe = useStripe()
	const elements = useElements()
	const [status,setStatus] = useState('idle')
	const dispatch = useDispatch()

	const taxPercent = useSelector(
		state=>state.settings.app.tax_percent || 0
	)
	
	console.log(taxPercent)
	console.log(invoice)

	const {forms} = usePurchaseItemForms(invoice.item_type,invoice.item_id)

	const confirmIntent = () => {

		if (invoice.item_type==='subscription') {
			return stripe.confirmSetup({
				elements,
				confirmParams: {
					return_url: 'https://www.fitsw.com',
				},
				redirect:'if_required'
			})
		} else {
			return stripe.confirmPayment({
				elements,
				confirmParams: {
					return_url: 'https://www.fitsw.com',
				},
				redirect:'if_required'
			})
		}
	}

	const finalizeIntent = (payload) => {
		//map from item type to correct endpoint
		const typeEndpointMap = {
			package:'api/purchases/trainer_page/',
			session:'api/purchases/trainer_page/',
			custom_payment:'api/purchases/trainer_page/',
			subscription:'api/subscriptions/',
			merchandise:'api/merchandise/',
		}
		return (
			envAwarePost(typeEndpointMap[invoice.item_type], payload)
		)
	}

	const forwardToForms = (forms,programs) => {
		//assign the forms to the client then forward to 
		//the modal for them to fill out the newly assigned forms
		envAwarePost('api/customForms/',{
			action:'addFormsToClient',
			form_ids:forms.map(form=>form.id),
		}).then(()=>{
			dispatch(setMultiFormsModal({
				show:true,
				programs,
				forms
			}))
		})
	}

	//if packages were purchased that had associated programs 
	//forward to the program assignemnt options
	const forwardToProgramPackageAssignment = programs => {
		//get all packages with these programs
		dispatch(updateProgramAssign({
			show:true,
			programs
		}))
	}

	const handlePayNow = async (e)=>{
		// Block native form submission.
		e.preventDefault();

		if (!stripe || !elements) {
			// Stripe.js has not loaded yet. Make sure to disable
			// form submission until Stripe.js has loaded.
			return;
		}

		setStatus('pending')
		confirmIntent()
		.then( res => {
			if (res.error) throw new Error(res.error.message)
			const intentFailed = (
				invoice.item_type === 'subscription'
				? res.setupIntent.status !== 'succeeded'
				: res.paymentIntent.status !== 'succeeded'
			)
			if (intentFailed) {
				throw new Error("Something went wrong. Please, try again")
			}
			const stripe_user_id = invoice.connect_account.stripe_user_id
			const payload = {
				is_public_api_request:1,
				owner_id:invoice.owner_id,
				stripe_user_id,
			}
			if (invoice.item_type==='subscription') {
				payload.action =  'finalizeSubscription'
				payload.setup_intent_id = res.setupIntent.id
			} else {
				payload.action =  'finalizePaymentIntent'
				payload.payment_intent_id = res.paymentIntent.id
			}
			return finalizeIntent(payload)
		}).then( res => {
			if (res.success === '1') {
				setStatus('idle')
				//this handles the non-logged in state
				dispatch(markInvoicePaid(invoice))
				//this updates the data for a logged in client
				dispatch(editInvoice({id:invoice.id,update:{paid:1}}))
				if (forms.length>0){ 
					forwardToForms(forms,invoice.item?.programs || [])
				} else if(invoice.item?.programs?.length > 0){
					forwardToProgramPackageAssignment(invoice.item?.programs)
				}
			} else {
				throw new Error(res.message)
			}
		}).catch( err => {
			setStatus('idle')
			window.alert(err)
		})
	}

	const handleNameChange = (e)=>{
		dispatch(updateName(e.target.value))
	}

	return (
		<div 
			style={{width:'600px',maxWidth:'100%'}}
			className="p-5 m-auto" 
		>
			{!Boolean(invoice.non_client)?
				<div>
					{Boolean(invoice.recipient.profile_pic)&&
						<img 
							src={invoice.recipient.profile_pic.url}
							style={{
								objectFit:'cover',
								height:'80px',
								width:'80px',
								borderRadius:'200px',
								display:'block',
								margin:'auto'
							}}
						/>
					}
					<div className="text-center">
						<strong>{invoice.recipient.user_name}</strong>
					</div>
				</div>
				:
				<div>
					<strong>Name</strong>
					<Form.Control
						onChange={handleNameChange}
						value={invoice.recipient.user_name}
						placeholder="Name"
					/>
					<strong>Email</strong>
					<Form.Control disabled placeholder="Email" value={invoice.recipient_email}/>
				</div>
			}
			<div className="text-center text-muted">
				<small>
					Created: <LocaleDate date={new Date(invoice.date_created.split(' ').join('T'))}/>
				</small>
			</div>
			<div className="text-right">
				<small>Qty</small>
			</div>
			<hr className="my-2"/>
			<div className="d-flex justify-content-between mt-3">
				<div className="mr-2">
					{invoice.line_item.item_name}
				</div>
				<LocaleCurrency
					amount={invoice.line_item.price}
					ISO={invoice.line_item.iso}
				/>
				<div className="ml-2">{invoice.line_item.qty}</div>
			</div>
			<hr className="my-2"/>
			<div className="text-right">
				<strong>
					<span className="mr-2">Total:</span>
					<LocaleCurrency
						amount={(invoice.line_item.total*(1+taxPercent/100)).toFixed(2)}
						ISO={invoice.line_item.iso}
					/>
				</strong>
			</div>
			{taxPercent>0&&
				<div className="text-right text-info">
					<small>
						{taxPercent}% tax has been applied.
					</small>
				</div>
			}
			<div>
				<PaymentElement
					options={{
						hidePostalCode: true,
						style: {
							base: {
								fontSize: '16px',
								color: '#424770',
								'::placeholder': {
									color: '#aab7c4',
								},
							},
							invalid: {
								color: '#9e2146',
							},
						},
					}}
				/>
				<div className="text-right mt-2">
					<Button 
						variant="outline-success"
						onClick={handlePayNow}
						disabled={status==='pending'}
					>
						Pay Now {status==='pending'&&<Spinner animation="border" size="sm"/>}
					</Button>
				</div>
			</div>
		</div>
	)
}

const StripeContainer = ({invoice})=>{
	const stripePromise = useStripePromise(invoice?.connect_account?.stripe_user_id)
	const taxPercent = useSelector(
		state=>state.settings.app.tax_percent || 0
	)
	//takes an invoice and generates the api payload to send 
	//to the specific endpoint
	const invoiceToPayload = invoice => {
		if(invoice.item_type==='package'){
			const paymentAmount = Math.round(parseFloat(invoice.item.package_price)*invoice.qty*100*(1+taxPercent/100))
			const clientEmail = invoice.recipient.user_email
			const clientName = invoice.recipient.user_name
			const trainer_id = invoice.owner_id
			const numSessions = invoice.item.session_credits*invoice.qty
			const paymentType = invoice.item_type
			const package_currency_id = invoice.item.presentment_currency_id
			const create_prospect = parseInt(invoice.item.create_client)^1
			const payload =  {
				action:'getPaymentIntent',
				paymentAmount,
				clientEmail,
				trainer_id,
				numSessions,
				create_prospect,
				purchase_description:`Package: ${invoice.qty} ${invoice.item.package_name}`,
				clientName,
				paymentType,
				package_currency_id
			}
			return payload
		}
		if(invoice.item_type==='custom_payment'){
			const paymentAmount = parseFloat(invoice.item.amount)*100
			const clientEmail = invoice.recipient.user_email
			const clientName = invoice.recipient.user_name
			const trainer_id = invoice.owner_id
			const numSessions = 0
			const paymentType = invoice.item_type
			const package_currency_id = invoice.item.presentment_currency_id
			const payload =  {
				action:'getPaymentIntent',
				paymentAmount,
				clientEmail,
				trainer_id,
				numSessions,
				clientName,
				paymentType,
				package_currency_id
			}
			return payload
		}
		if(invoice.item_type==='session'){
			const paymentAmount = parseFloat(invoice.item.rate)*100*invoice.qty
			const clientEmail = invoice.recipient.user_email
			const clientName = invoice.recipient.user_name
			const trainer_id = invoice.owner_id
			const numSessions = invoice.qty
			const paymentType = invoice.item_type
			const package_currency_id = invoice.item.presentment_currency_id
			const payload =  {
				action:'getPaymentIntent',
				paymentAmount,
				clientEmail,
				trainer_id,
				numSessions,
				clientName,
				paymentType,
				package_currency_id
			}
			return payload
		}
		if(invoice.item_type==='merchandise'){
			const payload = {
				action:'getPaymentIntent',
				is_public_api_request:1,
				owner_id:invoice.owner_id,
				email:invoice.recipient.user_email,
				name:invoice.recipient.user_name,
				items:[{
					id:invoice.item.id,
					qty:invoice.qty
				}]
			}
			return payload
		}
		if(invoice.item_type==='subscription'){
			const payload = {
				action:'getSetupIntent',
				is_public_api_request:1,
				trainer_id:invoice.owner_id,
				email:invoice.recipient.user_email,
				name:invoice.recipient.user_name,
				subscription_id:invoice.item_id
			}
			return payload
		}
		return {}
	}

	const getIntent = payload => {
		//map from item type to correct endpoint
		const typeEndpointMap = {
			package:'api/purchases/trainer_page/',
			session:'api/purchases/trainer_page/',
			custom_payment:'api/purchases/trainer_page/',
			subscription:'api/subscriptions/',
			merchandise:'api/merchandise/',
		}
		return (
			envAwarePost(
				typeEndpointMap[invoice.item_type], 
				payload
			)
		)
	}

	const getResClientSecret = res => {
		if(['package','custom_payment','session'].includes(invoice.item_type)){
			return res.data
		}else{
			return res.data.client_secret
		}
	}

	const [clientSecret,setClientSecret] = useState(null)

	useEffect(async ()=>{
		const res = await getIntent(invoiceToPayload(invoice))
		setClientSecret(getResClientSecret(res))
	},[])

	return (
		(Boolean(stripePromise)&&Boolean(clientSecret))&&
		<Elements stripe={stripePromise} options={{clientSecret}}>
			<ElementsConsumer>
				{({ elements, stripe }) => (
					<Invoice
						elements={elements}
						stripe={stripe}
						invoice={invoice}
					/>
				)}
			</ElementsConsumer>
		</Elements>
	)
}

const PayInvoice = ({location})=>{
	const params = new URLSearchParams(location.search)
	const token = params.get('token')
	const dispatch = useDispatch()
	const {status,invoice} = useSelector( state => state.payInvoice )
	
	useEffect(()=>{
		dispatch(getInvoice(token))
	},[])

	if (status==='pending') return (
		<div className="p-5">
			<CenteredLoader/>
		</div>
	)

	if (status==='idle'&&!invoice) return (
		<div className="p-5 text-center">
			This invoice no longer exists
		</div>
	)

	if (invoice&&invoice.paid) return (
		<div className="p-5 text-center">
			This invoice has been paid. Check your email for a receipt.
		</div>
	)

	return <StripeContainer invoice={invoice}/>
}

export default PayInvoice